import { type NodeSpec } from "prosemirror-model";

export const columns: NodeSpec = {
	group: "block",
	content: "block+",
	attrs: {
		columns: { default: 2, validate: "number" },
	},
	parseDOM: [
		{
			tag: 'section[data-node-type="columns"]',
			getAttrs: (node) => {
				return { columns: node.dataset["columns"] };
			},
		},
	],
	toDOM(mark) {
		return [
			"section",
			{
				"data-node-type": "columns",
				"data-columns": mark.attrs["columns"],
				"style": `columns: ${mark.attrs["columns"]}`,
			},
			0,
		];
	},
};
